import { BRAND, isMarketGB } from 'src/constants/main';
import { InfoButtonStyled } from './InfoButtonStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { InfoButtonStyledAC } from './AC/InfoButtonStyledAC';
import { InfoButtonStyledAP } from './AP/InfoButtonStyledAP';
import { InfoButtonStyledDS } from './DS/InfoButtonStyledDS';
import { InfoButtonStyledOV } from './OV/InfoButtonStyledOV';
import { InfoButtonStyledOVGB } from './OV/InfoButtonStyledOVGB';

export interface InfoButtonProps extends SC {
    onClick: () => void
}

export const InfoButton = (props: InfoButtonProps) => {
    if (BRAND === 'AC') return <InfoButtonStyledAC {...props} />;
    if (BRAND === 'AP') return <InfoButtonStyledAP {...props} />;
    if (BRAND === 'DS') return <InfoButtonStyledDS {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <InfoButtonStyledOVGB {...props} /> : <InfoButtonStyledOV {...props} />;
    return <InfoButtonStyled {...props} />;
};

export default InfoButton;
